import React from 'react';
import { View, Text, Heading, Button } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <View style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      position: 'relative'
    }}>
      {/* Background gradient */}
      <View
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          zIndex: -1
        }}
      >
        {/* Animated bubbles */}
        <View style={{ position: 'absolute', top: '-100px', left: '-100px', width: '300px', height: '300px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)', animation: 'float 6s ease-in-out infinite' }} />
        <View style={{ position: 'absolute', bottom: '-150px', right: '-150px', width: '400px', height: '400px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)', animation: 'float 8s ease-in-out infinite reverse' }} />
        <View style={{ position: 'absolute', top: '40%', left: '10%', width: '250px', height: '250px', borderRadius: '50%', background: 'rgba(255,255,255,0.06)', animation: 'float 10s ease-in-out infinite' }} />
      </View>

      {/* Main Content */}
      <View style={{ 
        flex: 1, 
        padding: '2rem',
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto'
      }}>
        <View style={{
          background: 'rgba(30, 35, 45, 0.85)',
          backdropFilter: 'blur(20px)',
          borderRadius: '20px',
          padding: '3rem',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}>
          <Heading level={1} style={{ 
            color: 'white', 
            marginBottom: '0.5rem',
            fontSize: '2.5rem',
            textAlign: 'center'
          }}>
            Terms of Service
          </Heading>
          
          <Text style={{ 
            color: 'rgba(255,255,255,0.7)', 
            textAlign: 'center',
            marginBottom: '2rem'
          }}>
            Last updated: August 2025
          </Text>

          {/* Important Warnings */}
          <View style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2rem'
          }}>
            <View style={{ 
              background: 'rgba(254, 215, 215, 0.1)', 
              border: '2px solid rgba(245, 101, 101, 0.5)',
              borderRadius: '10px',
              padding: '1rem'
            }}>
              <Text style={{ color: '#FCA5A5', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                ⚠️ AI-Generated Content
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                All CV feedback is generated by OpenAI GPT-4o artificial intelligence. 
                This is NOT human career advice. Critically evaluate all suggestions.
              </Text>
            </View>

            <View style={{ 
              background: 'rgba(254, 215, 215, 0.1)', 
              border: '2px solid rgba(245, 101, 101, 0.5)',
              borderRadius: '10px',
              padding: '1rem'
            }}>
              <Text style={{ color: '#FCA5A5', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                ⚠️ No Professional Advice
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.9rem' }}>
                This service does not provide professional career counselling or guarantee 
                job placement. It is a tool to assist your search, not a replacement for expertise.
              </Text>
            </View>
          </View>

          {/* Grid Layout */}
          <View style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
            gap: '2rem',
            color: 'white',
            lineHeight: '1.6'
          }}>
            {/* Section 1 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                1. Service Description
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.5rem' }}>
                Campus2Career provides:
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Aggregated job listings from external sources
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • AI-powered CV analysis and suggestions
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Job-CV compatibility assessments
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • Secure CV storage and management
              </Text>
            </View>

            {/* Section 2 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                2. Acceptance of Terms
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                By accessing Campus2Career, you agree to these Terms. 
                If you disagree with any part, you must not use the service. 
                Creating an account constitutes acceptance of all terms.
              </Text>
            </View>

            {/* Section 3 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                3. User Responsibilities
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Provide accurate account information
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Maintain account security
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Upload only your own CVs
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Use the service lawfully
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • Verify AI suggestions before use
              </Text>
            </View>

            {/* Section 4 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                4. Intellectual Property
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.5rem' }}>
                <strong>Your Content:</strong> You retain all rights to your CV. 
                You grant us limited licence to process it for services.
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                <strong>AI Content:</strong> Suggestions are for your personal use. 
                The AI model remains OpenAI's property.
              </Text>
            </View>

            {/* Section 5 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                5. Third-Party Services
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • <strong>OpenAI:</strong> AI analysis (CV sent for processing)
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • <strong>Reed API:</strong> Job listings (not affiliated)
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.5rem' }}>
                • <strong>AWS:</strong> Infrastructure and storage
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                We're not responsible for third-party content accuracy.
              </Text>
            </View>

            {/* Section 6 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                6. Limitation of Liability
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Service provided "AS IS" without warranties
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Not liable for application outcomes
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Not responsible for AI accuracy
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Not liable for job listing errors
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • Maximum liability: £100
              </Text>
            </View>

            {/* Section 7 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                7. Account Termination
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.5rem' }}>
                You may delete your account anytime. We may suspend accounts for:
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Terms violations
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Fraudulent activity
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Service abuse
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • Inappropriate content
              </Text>
            </View>

            {/* Section 8 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                8. Data Protection
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • CVs encrypted with AES-256
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Analysis deleted after 30 days
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Data deletion on request
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • GDPR compliant practices
              </Text>
            </View>

            {/* Section 9 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                9. Prohibited Uses
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Uploading others' personal data
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Automated scraping or bots
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Malicious or harmful content
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '0.3rem' }}>
                • Copyright infringement
              </Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                • Commercial resale of services
              </Text>
            </View>

            {/* Section 10 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                10. Accessibility
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                We aim to meet WCAG 2.1 Level AA standards for accessibility. 
                The platform is designed to be usable across devices and assistive technologies.
              </Text>
            </View>

            {/* Section 11 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                11. Changes to Terms
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                We may update these terms periodically. Continued use after changes 
                constitutes acceptance. Material changes will be notified via the platform.
              </Text>
            </View>

            {/* Section 12 */}
            <View>
              <Heading level={3} style={{ color: '#667eea', marginBottom: '1rem' }}>
                12. Governing Law
              </Heading>
              <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                These terms are governed by the laws of England and Wales. 
                Disputes shall be resolved in the courts of England and Wales.
              </Text>
            </View>
          </View>

          {/* Final Agreement Box */}
          <View style={{ 
            background: 'rgba(102, 126, 234, 0.1)', 
            border: '2px solid rgba(102, 126, 234, 0.5)',
            borderRadius: '10px',
            padding: '1rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}>
            <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
              By using Campus2Career, you acknowledge that you have read, understood, 
              and agree to these Terms of Service and our Privacy Policy.
            </Text>
          </View>

          <Button
            onClick={() => navigate('/')}
            style={{
              marginTop: '2rem',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '25px',
              padding: '0.75rem 2rem',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            Back to Home
          </Button>
        </View>
      </View>
    </View>
  );
};

export default TermsOfService;